export class DateHelper {
  static utcToLocalString(
    utcDate: string | Date | null,
    format: string = 'dd/MM/yyyy HH:mm:ss',
  ): string {
    if (!utcDate) return '';

    const date = new Date(utcDate);
    const options: Intl.DateTimeFormatOptions = {
      timeZone: 'America/Sao_Paulo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };

    if (format === 'dd/MM/yyyy') {
      delete options.hour;
      delete options.minute;
      delete options.second;
    }

    return new Intl.DateTimeFormat('pt-BR', options).format(date);
  }

  static localToUtc(localDate: Date | string): string {
    if (!localDate) return '';

    const date =
      typeof localDate === 'string' ? new Date(localDate) : localDate;

    return date.toISOString();
  }

  static localStringToUtc(dateString: string): string {
    if (!dateString) return '';

    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('/');
    const [hours, minutes, seconds] = (timePart || '00:00:00').split(':');

    const date = new Date(
      `${year}-${month}-${day}T${hours}:${minutes}:${seconds}-03:00`,
    );

    return date.toISOString();
  }

  static nowUtc(): string {
    return new Date().toISOString();
  }
}
